module.exports = __webpack_public_path__ + "3602b7e8b2cb1462b0bef9738757ef8a.svg";